import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import {
  GetAdminNotificationsInputDto,
  GetAdminNotificationsOutputDto,
} from '../../../models/notifications/dto/admin-notification.dto';

export const GET_ADMIN_NOTIFICATIONS_QUERY_KEY = 'admin-notifications';

export const useGetNotifications = (params: GetAdminNotificationsInputDto) => {
  const client = useApiClient();

  const page = params.page ?? 0;
  const limit = params.limit ?? 20;
  const organizationId = params.organizationId;
  const type = params.type;
  const search = params.search;

  return useQuery({
    queryKey: [GET_ADMIN_NOTIFICATIONS_QUERY_KEY, page, limit, organizationId, type, search],
    queryFn: async () => {
      const queryParams = new URLSearchParams();
      queryParams.append('page', page.toString());
      queryParams.append('limit', limit.toString());
      if (organizationId) {
        queryParams.append('organizationId', organizationId);
      }
      if (type) {
        queryParams.append('type', type);
      }
      if (search) {
        queryParams.append('search', search);
      }

      return client.fetchApi<GetAdminNotificationsOutputDto, {}>({
        endpoint: `notifications/admin?${queryParams.toString()}`,
        method: 'GET',
      });
    },
    enabled: !!organizationId,
    staleTime: 30 * 1000,
    cacheTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });
};
